import { extractCorePost } from "../../../utils/posts";
import { LoadedDraft, Post } from "../../../shared/types/post";
import { CreatePostRequest } from "./bulk-create-post.types";

type DuplicateSource = Post | LoadedDraft | Partial<Post>;

export function duplicatePostForCreate(
  source: DuplicateSource,
  defaultPostStatusKey?: string | null
): Partial<Post> {
  const normalized = extractCorePost(
    source as Post | LoadedDraft
  ) as Partial<Post>;
  const accountIds = normalized.accountIds?.length
    ? normalized.accountIds
    : normalized.accountId
      ? [normalized.accountId]
      : [];

  const duplicated: Partial<Post> & Record<string, unknown> = {
    ...normalized,
    accountIds,
    postStatusKey: defaultPostStatusKey ?? null,
    when: undefined,
    scheduledFor: undefined,
    nextRunAt: undefined,
    lastRunAt: undefined,
    timestamp: undefined,
    postType: undefined,
    originalPostType: undefined,
    originalPostState: undefined,
    postState: undefined,
    queued: false,
    isQueued: false,
    isNow: false,
    isSuccess: false,
    isCanceled: false,
    isPosting: false,
    isPotentialError: false,
    past: false,
    failedAt: undefined,
    failReason: undefined,
    userDisplayReason: undefined,
    postClusterId: undefined,
  };

  for (const key of [
    "_id",
    "id",
    "accounts",
    "accountName",
    "createdAt",
    "createdBy",
    "updatedAt",
    "updatedBy",
    "postedBy",
    "state",
    "newPost",
    "platformPostId",
    "metrics",
    "importedAt",
    "isImported",
    "unreadMessageCount",
    "preview_enabled",
    "checked",
    "overlaps",
    "dateRange",
    "hash",
    "clientId",
    "plannerAccount",
    "ordinal",
  ] as const) {
    delete duplicated[key];
  }

  if (duplicated.isFbReel === true || duplicated.type === "fb-reel") {
    duplicated.isFbReel = true;
    duplicated.isVideo = true;
    duplicated.videoPostType = "reel";
    duplicated.type = "fb-reel";
  }

  return duplicated;
}

export function buildDuplicateCreateRequests(
  posts: DuplicateSource[],
  defaultPostStatusKey?: string | null
): CreatePostRequest[] {
  return posts.map((post) => ({
    type: "create" as const,
    post: duplicatePostForCreate(post, defaultPostStatusKey),
  }));
}
